import * as React from "react";
import { Link } from "react-router-dom";

import { Box, CircularProgress } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

interface IProps {
    readonly code: string;
    readonly thumbnailUrl: string;
}

export function QuiltThumbnail(props: IProps): React.ReactElement {
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);

    const onError = () => {
        setLoaded(true);
        setError(true);
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <Link to={`q/${props.code}`}>
                <img
                    loading="lazy"
                    src={"thumbnail/" + props.thumbnailUrl}
                    alt=""
                    onLoad={() => setLoaded(true)}
                    onError={onError} />
                {error && <ErrorOutlineIcon /> }
                {!loaded &&  <CircularProgress size="1rem" /> }
            </Link>
        </Box>
    );
}